var map = {
	"../avis-expert/avis-expert.module": [
		"./src/app/pages/avis-expert/avis-expert.module.ts",
		"avis-expert-avis-expert-module"
	],
	"../bet-settings/bet-settings.module": [
		"./src/app/pages/bet-settings/bet-settings.module.ts",
		"bet-settings-bet-settings-module"
	],
	"../bonus-settings/bonus-settings.module": [
		"./src/app/pages/bonus-settings/bonus-settings.module.ts",
		"bonus-settings-bonus-settings-module"
	],
	"../cashout-settings/cashout-settings.module": [
		"./src/app/pages/cashout-settings/cashout-settings.module.ts",
		"cashout-settings-cashout-settings-module"
	],
	"../categories/categories.module": [
		"./src/app/pages/categories/categories.module.ts",
		"categories-categories-module"
	],
	"../channel-detail/channel-detail.module": [
		"./src/app/pages/channel-detail/channel-detail.module.ts",
		"channel-detail-channel-detail-module"
	],
	"../channels/channels.module": [
		"./src/app/pages/channels/channels.module.ts",
		"channels-channels-module"
	],
	"../client-detail/client-detail.module": [
		"./src/app/pages/client-detail/client-detail.module.ts",
		"default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~90c67f9e",
		"default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~faa9ccf4",
		"default~client-detail-client-detail-module~partner-detail-partner-detail-module",
		"default~client-detail-client-detail-module~dashboard-dashboard-module",
		"common",
		"client-detail-client-detail-module"
	],
	"../demo-accounts-management/demo-accounts-management.module": [
		"./src/app/pages/demo-accounts-management/demo-accounts-management.module.ts",
		"demo-accounts-management-demo-accounts-management-module"
	],
	"../event-detail/event-detail.module": [
		"./src/app/pages/event-detail/event-detail.module.ts",
		"event-detail-event-detail-module"
	],
	"../event-restriction/event-restriction.module": [
		"./src/app/pages/event-restriction/event-restriction.module.ts",
		"event-restriction-event-restriction-module"
	],
	"../events/events.module": [
		"./src/app/pages/events/events.module.ts",
		"events-events-module"
	],
	"../footer-content/footer-content.module": [
		"./src/app/pages/footer-content/footer-content.module.ts",
		"common",
		"footer-content-footer-content-module"
	],
	"../freebet-assignment/freebet-assignment.module": [
		"./src/app/pages/freebet-assignment/freebet-assignment.module.ts",
		"common",
		"freebet-assignment-freebet-assignment-module"
	],
	"../game-lists/game-lists.module": [
		"./src/app/pages/game-lists/game-lists.module.ts",
		"default~game-lists-game-lists-module~publicity-publicity-module~slidder-detail-slidder-detail-module~1044debe",
		"game-lists-game-lists-module"
	],
	"../group/group.module": [
		"./src/app/pages/group/group.module.ts",
		"group-group-module"
	],
	"../manage-clients/manage-clients.module": [
		"./src/app/pages/manage-clients/manage-clients.module.ts",
		"default~manage-clients-manage-clients-module~manage-exclusions-manage-exclusions-module~manage-limit~65cc4550",
		"common",
		"manage-clients-manage-clients-module"
	],
	"../manage-exclusions/manage-exclusions.module": [
		"./src/app/pages/manage-exclusions/manage-exclusions.module.ts",
		"default~manage-clients-manage-clients-module~manage-exclusions-manage-exclusions-module~manage-limit~65cc4550",
		"common",
		"manage-exclusions-manage-exclusions-module"
	],
	"../manage-limits/manage-limits.module": [
		"./src/app/pages/manage-limits/manage-limits.module.ts",
		"default~manage-clients-manage-clients-module~manage-exclusions-manage-exclusions-module~manage-limit~65cc4550",
		"common",
		"manage-limits-manage-limits-module"
	],
	"../manual-market/manual-market.module": [
		"./src/app/pages/manual-market/manual-market.module.ts",
		"manual-market-manual-market-module"
	],
	"../market/market.module": [
		"./src/app/pages/market/market.module.ts",
		"market-market-module"
	],
	"../nav/nav.module": [
		"./src/app/pages/nav/nav.module.ts",
		"common",
		"nav-nav-module"
	],
	"../notification-settings/notifications.module": [
		"./src/app/pages/notification-settings/notifications.module.ts",
		"notification-settings-notifications-module"
	],
	"../package-config/package-config.module": [
		"./src/app/pages/package-config/package-config.module.ts",
		"package-config-package-config-module"
	],
	"../partner-detail/partner-detail.module": [
		"./src/app/pages/partner-detail/partner-detail.module.ts",
		"default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~90c67f9e",
		"default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~faa9ccf4",
		"default~client-detail-client-detail-module~partner-detail-partner-detail-module",
		"partner-detail-partner-detail-module"
	],
	"../partner-revenue-share/partner-revenue-share.module": [
		"./src/app/pages/partner-revenue-share/partner-revenue-share.module.ts",
		"partner-revenue-share-partner-revenue-share-module"
	],
	"../partners/partners.module": [
		"./src/app/pages/partners/partners.module.ts",
		"partners-partners-module"
	],
	"../payments/payments.module": [
		"./src/app/pages/payments/payments.module.ts",
		"payments-payments-module"
	],
	"../phone-numbers/phone-numbers.module": [
		"./src/app/pages/phone-numbers/phone-numbers.module.ts",
		"phone-numbers-phone-numbers-module"
	],
	"../product-type/product-type.module": [
		"./src/app/pages/product-type/product-type.module.ts",
		"product-type-product-type-module"
	],
	"../products/products.module": [
		"./src/app/pages/products/products.module.ts",
		"products-products-module"
	],
	"../promotions/promotions.module": [
		"./src/app/pages/promotions/promotions.module.ts",
		"promotions-promotions-module"
	],
	"../providers/providers.module": [
		"./src/app/pages/providers/providers.module.ts",
		"providers-providers-module"
	],
	"../publicity/publicity.module": [
		"./src/app/pages/publicity/publicity.module.ts",
		"default~game-lists-game-lists-module~publicity-publicity-module~slidder-detail-slidder-detail-module~1044debe",
		"common",
		"publicity-publicity-module"
	],
	"../results/results.module": [
		"./src/app/pages/results/results.module.ts",
		"results-results-module"
	],
	"../risk-configurations/risk-configurations.module": [
		"./src/app/pages/risk-configurations/risk-configurations.module.ts",
		"risk-configurations-risk-configurations-module"
	],
	"../speciale-cagnotte/speciale-cagnotte.module": [
		"./src/app/pages/speciale-cagnotte/speciale-cagnotte.module.ts",
		"speciale-cagnotte-speciale-cagnotte-module"
	],
	"../sport-promotions/sport-promotions.module": [
		"./src/app/pages/sport-promotions/sport-promotions.module.ts",
		"common",
		"sport-promotions-sport-promotions-module"
	],
	"../sports/sports.module": [
		"./src/app/pages/sports/sports.module.ts",
		"sports-sports-module"
	],
	"../suspended-tickets/suspended-tickets.module": [
		"./src/app/pages/suspended-tickets/suspended-tickets.module.ts",
		"default~dashboard-dashboard-module~suspended-tickets-suspended-tickets-module~tickets-tickets-module",
		"default~suspended-tickets-suspended-tickets-module~tickets-tickets-module",
		"suspended-tickets-suspended-tickets-module"
	],
	"../tax-configuration/tax-configurations.module": [
		"./src/app/pages/tax-configuration/tax-configurations.module.ts",
		"tax-configuration-tax-configurations-module"
	],
	"../tax-payment/tax-payment.module": [
		"./src/app/pages/tax-payment/tax-payment.module.ts",
		"tax-payment-tax-payment-module"
	],
	"../text-slidders/text-slidders.module": [
		"./src/app/pages/text-slidders/text-slidders.module.ts",
		"default~game-lists-game-lists-module~publicity-publicity-module~slidder-detail-slidder-detail-module~1044debe",
		"text-slidders-text-slidders-module"
	],
	"../tickets/tickets.module": [
		"./src/app/pages/tickets/tickets.module.ts",
		"default~dashboard-dashboard-module~suspended-tickets-suspended-tickets-module~tickets-tickets-module",
		"default~suspended-tickets-suspended-tickets-module~tickets-tickets-module",
		"default~dashboard-dashboard-module~tickets-tickets-module",
		"tickets-tickets-module"
	],
	"../tournaments/tournaments.module": [
		"./src/app/pages/tournaments/tournaments.module.ts",
		"tournaments-tournaments-module"
	],
	"./bonus-details/bonus-details.module": [
		"./src/app/pages/bonus-settings/bonus-details/bonus-details.module.ts",
		"bonus-details-bonus-details-module"
	],
	"./cagnotte-detail/cagnotte-detail.module": [
		"./src/app/pages/speciale-cagnotte/cagnotte-detail/cagnotte-detail.module.ts",
		"default~cagnotte-detail-cagnotte-detail-module~game-detail-game-detail-module~promotion-details-prom~cd2e0bb8",
		"cagnotte-detail-cagnotte-detail-module"
	],
	"./category/category.module": [
		"./src/app/pages/categories/category/category.module.ts",
		"category-category-module"
	],
	"./game-detail/game-detail.module": [
		"./src/app/pages/game-lists/game-detail/game-detail.module.ts",
		"default~cagnotte-detail-cagnotte-detail-module~game-detail-game-detail-module~promotion-details-prom~cd2e0bb8",
		"game-detail-game-detail-module"
	],
	"./group-detail/group-detail.module": [
		"./src/app/pages/group/group-detail/group-detail.module.ts",
		"group-detail-group-detail-module"
	],
	"./limits-management/limits-management.module": [
		"./src/app/pages/risk-configurations/limits-management/limits-management.module.ts",
		"limits-management-limits-management-module"
	],
	"./market-detail/market-detail.module": [
		"./src/app/pages/market/market-detail/market-detail.module.ts",
		"market-detail-market-detail-module"
	],
	"./notification-detail/notification-detail.module": [
		"./src/app/pages/notification-settings/notification-detail/notification-detail.module.ts",
		"notification-detail-notification-detail-module"
	],
	"./package-detail/package-detail.module": [
		"./src/app/pages/package-config/package-detail/package-detail.module.ts",
		"package-detail-package-detail-module"
	],
	"./partner-revenue-share-details/partner-revenue-share-details.module": [
		"./src/app/pages/partner-revenue-share/partner-revenue-share-details/partner-revenue-share-details.module.ts",
		"default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~90c67f9e",
		"default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~faa9ccf4",
		"partner-revenue-share-details-partner-revenue-share-details-module"
	],
	"./payments-details/payments-details.module": [
		"./src/app/pages/payments/payments-details/payments-details.module.ts",
		"default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~90c67f9e",
		"payments-details-payments-details-module"
	],
	"./promotion-details/promotion-details.module": [
		"./src/app/pages/promotions/promotion-details/promotion-details.module.ts",
		"default~cagnotte-detail-cagnotte-detail-module~game-detail-game-detail-module~promotion-details-prom~cd2e0bb8",
		"promotion-details-promotion-details-module"
	],
	"./slidder-detail/slidder-detail.module": [
		"./src/app/pages/publicity/slidder-detail/slidder-detail.module.ts",
		"default~game-lists-game-lists-module~publicity-publicity-module~slidder-detail-slidder-detail-module~1044debe",
		"slidder-detail-slidder-detail-module"
	],
	"./slides-details/slides-details.module": [
		"./src/app/pages/avis-expert/slides-details/slides-details.module.ts",
		"default~cagnotte-detail-cagnotte-detail-module~game-detail-game-detail-module~promotion-details-prom~cd2e0bb8",
		"slides-details-slides-details-module"
	],
	"./sport-details/sport-details.module": [
		"./src/app/pages/sports/sport-details/sport-details.module.ts",
		"sport-details-sport-details-module"
	],
	"./tax-detail/tax-detail.module": [
		"./src/app/pages/tax-configuration/tax-detail/tax-detail.module.ts",
		"tax-detail-tax-detail-module"
	],
	"./tournament-detail/tournament-detail.module": [
		"./src/app/pages/tournaments/tournament-detail/tournament-detail.module.ts",
		"tournament-detail-tournament-detail-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;